import $ from 'jquery'

const SELECTORS = {
    productJson: '[data-product-json]'
}

class OptionSwitcher extends HTMLElement {
    constructor() {
        super()

        if (!document.querySelector(SELECTORS.productJson)) {
            console.error('no product json data found.')
            return
        }

        this.productSingleObject = JSON.parse($(SELECTORS.productJson).html())
        this.$singleOptionSelector = $('select', this)
    }

    connectedCallback() {
        this.$singleOptionSelector.on('change', (e) => this.updateVariant(e))
    }

    getVariant(selected) {
        const { variants } = this.productSingleObject
        const selectedVariant = variants.find((v) => v.title === selected)
        return selectedVariant || null
    }

    updateVariant(e) {
        const selected = e.target.value
        const variant = this.getVariant(selected)
        if (variant) {
            const variantUrl =
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname +
                '?variant=' +
                variant.id
            window.location = variantUrl
        }
    }
}

customElements.define('option-switcher', OptionSwitcher)
